import { render, staticRenderFns } from "./CreateAGMModal.vue?vue&type=template&id=10f7afdc"
import script from "./CreateAGMModal.vue?vue&type=script&lang=js"
export * from "./CreateAGMModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAGMModal.vue?vue&type=style&index=0&id=10f7afdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports